import { graphql } from 'react-apollo';
import log from 'chameleon/ui-stack/utilities/log';
import { courseOutline as courseOutlineQuery } from '../queries';
import { unitsClient } from 'legacy-src/utility/GraphqlClients';

const withCourseOutline = () =>
  graphql(courseOutlineQuery, {
    options: (props) => {
      const {
        params: { subject },
        userData: { chosenEducationPeriodCode },
      } = props;
      return {
        skip: !chosenEducationPeriodCode,
        client: unitsClient,
        variables: {
          subjectId: subject,
          educationPeriod: chosenEducationPeriodCode,
        },
        /**
         * Do not ever change cache-first
         * - this is used with a proper course outline configuration to cache it by react-apollo
         * */
        fetchPolicy: 'cache-first',
      };
    },
    props: ({ data }) => {
      const { loading } = data;
      if (loading) {
        return {
          courseOutline: {
            loading,
          },
        };
      }
      if (data.error) {
        log('error', data.error);
        return {
          courseOutline: {
            providerError: true,
            loading,
          },
        };
      }

      const { courseOutline } = data;

      return {
        courseOutline: {
          ...courseOutline,
          loading,
        },
      };
    },
    error: ({ data: { error } }) => {
      log('error', error);
      return {
        courseOutline: {
          loading: false,
          providerError: true,
        },
      };
    },
  });

export default withCourseOutline;
